if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"host","remotes":[{"alias":"wrapper","name":"ae2-2","entry":"https://achieving-excellence-ui.supplymgmt-strategic-direct-material-sour-prod-vpn.us.e15.c01.johndeerecloud.com/mf-manifest.json","shareScope":"default"}],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return 792 == chunkId},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}